import axios from 'axios';
import { BASE_URL } from './proxy';
const baseURL = 'https://us-central1-bestweddingappweb.cloudfunctions.net/';
export const reset = axios.create({ baseURL: baseURL });
